import customSoftware from "assets/images/services/customSoftware.svg";
import enterpriseIntegration from "assets/images/services/enterpriseIntegration.svg";
import erpIntegration from "assets/images/services/erpIntegration.svg";
import apiDevelopment from "assets/images/services/apiDevelopment.svg";
import aiAutomation from "assets/images/services/aiAutomation.svg";
import workflowAutomation from "assets/images/services/workflowAutomation.svg";
import productionSupport from "assets/images/services/productionSupport.svg";
import cloudDevops from "assets/images/services/cloudDevops.svg";

// Single source of truth for the service list and its order, shared by every
// navigation surface (header dropdown, footer). Keep the slugs aligned with
// servicesData. label + path are used everywhere; icon + desc are used by the
// header dropdown cards.
export const serviceLinks = [
  {
    label: "Custom Software Development",
    path: "/services/custom-software-development",
    icon: customSoftware,
    desc: "Software built around your business."
  },
  {
    label: "Enterprise System Integration",
    path: "/services/enterprise-system-integration",
    icon: enterpriseIntegration,
    desc: "Connect systems for unified data flow."
  },
  {
    label: "ERP Integration",
    path: "/services/erp-integration",
    icon: erpIntegration,
    desc: "Connect ERP across your enterprise."
  },
  {
    label: "API Development & Management",
    path: "/services/api-development-management",
    icon: apiDevelopment,
    desc: "Reliable, secure, well-managed APIs."
  },
  {
    label: "AI Automation",
    path: "/services/ai-automation",
    icon: aiAutomation,
    desc: "AI-driven automation, emerging capability."
  },
  {
    label: "Workflow Automation",
    path: "/services/workflow-automation",
    icon: workflowAutomation,
    desc: "Automate approvals and processes."
  },
  {
    label: "Production Support & Maintenance",
    path: "/services/production-support-maintenance",
    icon: productionSupport,
    desc: "Monitoring and SLA-based support."
  },
  {
    label: "Cloud & DevOps Solutions",
    path: "/services/cloud-devops-solutions",
    icon: cloudDevops,
    desc: "Cloud-native architecture and CI/CD."
  }
];

export default serviceLinks;
